import React, { Component } from "react";

import { Container, Row, Col, Table, Form } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonButton from '../components/CommonButton';
import CommonButtonBadge from '../components/CommonButtonBadge';
/**
import CommonDropdown from '../components/CommonDropdown';
*/
import CommonPagination from '../components/CommonPagination';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';

import * as fn from '../../library/function';
import * as util from '../../library/utilitys';
class DataTableMasterDataDistrict extends Component {

    render() {

        let props = this.props;

        let { onSetEdit, onNavigate, onDropDownChange, onCheckDelete, onCheckDeleteAll, onPaginationChange } = props;

        let { Action, DataTable, Inputs, Deletes } = props;

        let rowId = fn.getRowIdStart(DataTable.pagination);

        let deleteChecked = 0;
        DataTable.rows.forEach(row => {
            if (row.subdistrict_rows === 0) { deleteChecked++; }
        });

        return (
            <Container fluid className="data-table-container">

                <CommonDataTableLoading isLoading={Action.Loading.dataTable} />
    
                <Row>
                    <Col md={12}>
                        {DataTable?.rows?.length > 0 ? 
                            <Table 
                                responsive 
                                borderless 
                                className={`table-advance ${!Action.Loading.dataTable ? 'table-visible' : ''}`}
                            >
                                <thead >
                                    <tr>
                                        <th className="th-td-align-center th-width-50p">#</th>
                                        <th className="th-td-align-center th-width-100p">รหัส</th>
                                        <th className="th-width-auto">อำเภอ</th>
                                        <th className="th-td-align-center th-width-175p"></th>
                                        <th className="th-width-50p"></th>
                                        <th className="th-td-align-center th-width-50p">
                                            {deleteChecked > 0 && (
                                                <Form.Check 
                                                    type="checkbox"
                                                    checked={Deletes.checkAll}
                                                    onChange={(e) => onCheckDeleteAll(e, fn.getCheckboxAllItem('deletes'))} 
                                                />
                                            )}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {DataTable.rows.map((row, index) => {
                                        
                                        Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });

                                        rowId++;

                                        let del = true;
                                        if (row.subdistrict_rows > 0) { del = false; }

                                        return (
                                            <React.Fragment key={`${rowId}-${row.id}`}>
                                                <tr className={((rowId % 2) === 1) ? 'striped-row' : ''}>
                                                    <td className="th-td-align-center">
                                                        <CommonRowId rowId={rowId}/>
                                                    </td>
                                                    <td className="th-td-align-center">{row.district_id}</td>
                                                    <td className="text-truncate" title={row.district_name}>{row.district_name}</td>
                                                    <td>
                                                        <CommonButtonBadge 
                                                            info={{text: 'ตำบล', count: row.subdistrict_rows}}
                                                            rounded={false}
                                                            disabled={false}
                                                            callback={(e) => onNavigate(e, { element: [{ id: 'district_id', value: row.district_id, label: row.district_name}] })} 
                                                        />
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        <CommonButton 
                                                            task="edit" 
                                                            rounded={false}
                                                            disabled={false}
                                                            callback={(e) => onSetEdit(e, {id: row.district_id})} 
                                                        />
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        {del && (
                                                            <Form.Check 
                                                                type="checkbox"
                                                                name="deletes"
                                                                value={row.district_id}
                                                                checked={Deletes.deletes.includes(row.district_id)}
                                                                onChange={(e) => onCheckDelete(e)} 
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr className="table-row-gap"><td /></tr>
                                            </React.Fragment>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        :
                            <CommonRecordNotFound Action={Action} rows={DataTable.pagination.totalRows} />
                        }

                        {!Action.Loading.dataTable && (
                            <CommonPagination 
                                Pagination={DataTable.pagination} 

                                handlePagination={(paging) => onPaginationChange(paging)}
                            />
                        )}
                        
                    </Col>
                </Row>

            </Container>
        );
    }
}

export default DataTableMasterDataDistrict;
